import React from 'react';
import graphql from "babel-plugin-relay/macro";
import {useMutation} from "react-relay";
import dayjs from "dayjs";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {toast} from "react-toastify";
import HorizontalFormDate from "../../../components/common/horizontal-form-inputs/HorizontalFormDate";
import FormModal from "../../../components/common/modals/FormModal";
import {bandedSchema} from "../../../helpers/bandedUtils";

const EditPractitionerLocationPracticePeriodModal = ({showModal, onClose, selectedPracticePeriod}) => {
    const mutation = graphql`
    mutation EditPractitionerLocationPracticePeriodModalMutation($practitionerLocationPracticePeriodId: ID!,
    $effectiveFrom: DateOnly!, $effectiveTo: DateOnly!) {
        practitionerLocation {
            modifyPracticePeriod(input: {practitionerLocationPracticePeriodId: $practitionerLocationPracticePeriodId, 
                effectiveFrom: $effectiveFrom, effectiveTo: $effectiveTo}) {
                practitionerLocationPracticePeriod {
                    id
                    practitionerLocation {
                        practicePeriods {
                            ...PractitionerLocationPracticePeriods_PracticePeriod
                        }}}}}}`
    const [commitMutation, isInFlight] = useMutation(mutation)
    const effectiveFrom = selectedPracticePeriod?.effectiveFrom ? dayjs(selectedPracticePeriod.effectiveFrom).toDate() : '';
    const effectiveTo = selectedPracticePeriod?.effectiveTo ? dayjs(selectedPracticePeriod.effectiveTo).toDate() : '';
    const defaultValues = {
        practitionerLocationPracticePeriodId: selectedPracticePeriod?.id,
        effectiveFrom: effectiveFrom,
        effectiveTo: effectiveTo
    };
    const methods = useForm({values: defaultValues, resolver: yupResolver(bandedSchema)});
    const handleSubmit = (data) => {
        commitMutation({variables: {...data}, onCompleted: (data) => {
                if(data.practitionerLocation) {
                    toast.success("Practice Period for Provider Location updated")
                    methods.reset();
                    onClose();
                }
            }})
    }
    return (
        <FormModal showModal={showModal}
                   onClose={onClose}
                   title={"Update Practice Period"}
                   methods={methods}
                   isInFlight={isInFlight}
                   onSubmit={handleSubmit}
        >
            <HorizontalFormDate controlId={"effectiveFrom"} label={"Effective From"} />
            <HorizontalFormDate controlId={"effectiveTo"} label={"Effective To"} />
        </FormModal>
    )
}
export default EditPractitionerLocationPracticePeriodModal
